import { BranchModel } from '@shared/models/branch.model';
import { BranchServiceMode } from '@shared/enum/branch-service-mode.enum';

/** Parsed `branch` entry from localStorage, or null if missing/invalid. */
export function getBranchFromLocalStorage(): BranchModel | null {
  try {
    return JSON.parse(localStorage.getItem('branch') ?? 'null');
  } catch {
    return null;
  }
}

/**
 * Whether the current branch exposes the orders feature in the portal.
 * When `service_mode === MENU_ONLY (1)`, orders UI and `/orders` are disabled.
 * `Number()` normalizes API values that may arrive as strings.
 */
export function branchSupportsOrders(branch: BranchModel | null): boolean {
  // No branch payload: allow orders to avoid breaking legacy flows
  if (!branch) {
    return true;
  }
  return Number(branch.service_mode) !== BranchServiceMode.MENU_ONLY;
}

/**
 * Payment flows inside orders (details page, payment route, list badges) are only for
 * modes that include payment. `MENU_AND_ORDER` hides them; missing `service_mode` keeps legacy behavior.
 */
export function branchSupportsOrderPayments(branch: BranchModel | null): boolean {
  if (!branch) {
    return true;
  }
  const serviceMode = Number(branch.service_mode);
  return (
    serviceMode === BranchServiceMode.MENU_ORDER_AND_PAYMENT ||
    serviceMode === BranchServiceMode.MENU_AND_PAYMENT
  );
}
